import { VDatePicker } from 'vuetify/lib/components/VDatePicker';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDatePicker,_vm._g(_vm._b({attrs:{"type":"month","locale":"ru"}},'v-date-picker',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }